export default {
    activityItemsApprovals:         { method: 'post',   url: 'activity_items/approvals'},
}